import { DialogContentProps, DialogProps as RadixDialogProps } from '@radix-ui/react-dialog';
import React from 'react';

import { ButtonBaseProps } from '../Button/types';

export enum DialogSize {
  m = 'm',
  l = 'l',
  xl = 'xl',
  xxl = 'xxl'
}

export enum Type {
  alert = 'alert',
  success = 'success',
  warning = 'warning',
  info = 'info'
}

export enum IconPlacement {
  center = 'center',
  left = 'left',
  right = 'right'
}

export type DialogSizeType = `${DialogSize}`;
export type DialogType = `${Type}`;
export type IconPlacementType = `${IconPlacement}`;

export type DialogButtonProps =
  | (ButtonBaseProps & { block?: boolean; 'data-test-id'?: string } & Pick<
        React.ButtonHTMLAttributes<HTMLButtonElement>,
        'onClick'
      >)
  | null;

export enum DialogResponseAction {
  okButton = 'okButton',
  cancelButton = 'cancelButton',
  close = 'close'
}

export type DialogProps = RadixDialogProps & {
  children?: React.ReactNode;
  closable?: boolean;
  closeButton?: DialogButtonProps;
  okButton?: DialogButtonProps;
  ButtonsContainer?: React.ComponentType<{ children: React.ReactNode }>;
  trigger?: React.ReactNode;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  iconPlacement?: IconPlacementType;
  icon?: React.ReactNode;
  footer?: React.ReactNode;
  size?: DialogSizeType;
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
  onClose?: (action?: DialogResponseAction) => void;
  onOk?: () => void;
  showCloseIcon?: boolean;
  rootClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  isBlocking?: boolean;
  onCloseAutoFocus?: DialogContentProps['onCloseAutoFocus'];
  onOpenAutoFocus?: DialogContentProps['onOpenAutoFocus'];
  'data-test-id': string;
};

export type DialogUtilConfig = Omit<DialogProps, 'children'> & {
  children?:
    | React.ReactNode
    | ((params: { onOk: () => void; onClose: (action?: DialogResponseAction) => void }) => React.ReactNode);
};
